import { useI18n } from '../i18n/useI18n';
import { Alert } from '../ui/Alert';
import { NoticeScreen } from '../ui/AuthLayout';
import { Button } from '../ui/primitives';

/**
 * The console asked which console it is and did not get a usable answer.
 *
 * The only screen mounted without an entry point, and it stays that way: below
 * this there is no API client, no session and no routes, because all three
 * belong to one tree or the other. A retry is a reload rather than a second
 * request — whatever is wrong is on the other side, and a page that quietly
 * kept trying would look like a page that is loading.
 */
export function DidNotStartScreen({ detail }: { detail: string }) {
  const { t } = useI18n();

  return (
    <NoticeScreen>
      <Alert tone="deny" title={t('didNotStart.title')} live>
        <p>{t('didNotStart.body')}</p>
        <p className="mono" style={{ marginTop: 8 }}>
          {t('didNotStart.detail', { detail })}
        </p>
      </Alert>

      <div style={{ marginTop: 22 }}>
        <Button
          variant="ghost"
          block
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('didNotStart.retry')}
        </Button>
      </div>
    </NoticeScreen>
  );
}
